import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * Route wrapper that handles three states:
 *   - canAccess(featureKey) → render children
 *   - !canAccess && isLocked(featureKey) → redirect to /dashboard/locked/<key>
 *   - !canAccess && !isLocked → redirect to dashboard home (existing behavior)
 *
 * Drop-in replacement for `<RoleBasedRoute hasAccess={() => canAccess('xxx')} />`
 * for any route gated on a single feature key.
 */
export default function FeatureGate({ children, featureKey, redirectTo = '/dashboard' }) {
    const { canAccess, isLocked, loading } = useAuth();

    if (loading) {
        return (
            <div className="flex items-center justify-center h-screen">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
        );
    }

    if (canAccess(featureKey)) return children;
    if (isLocked(featureKey)) return <Navigate to={`/dashboard/locked/${featureKey}`} replace />;
    return <Navigate to={redirectTo} replace />;
}
